export var contentFooterClassName = 'smart-link-content-footer';
export var metadataListClassName = 'smart-link-metadata-list';
export var blockCardResolvingViewClassName = 'block-card-resolving-view';
export var blockCardResolvedViewClassName = 'block-card-resolved-view';
export var blockCardResolvedViewByClassName = 'block-card-resolved-view-by';
export var blockCardForbiddenViewClassName = 'block-card-forbidden-view';
export var blockCardForbiddenViewLinkClassName = 'block-card-forbidden-view-link';
export { blockCardIconImageClassName } from './view/common/Icon';
export var blockCardContentClassName = 'block-card-content';
export var blockCardContentHeaderClassName = 'block-card-content-header';
export var blockCardContentHeaderNameClassName = 'block-card-content-header-name';
export var blockCardNotFoundViewClassName = 'block-card-not-found-view';
export var blockCardErroredViewClassName = 'block-card-errored-view';